import './styles.css';

interface IProps {
  title: string;
}

export const OverlineTitle = ({ title }: IProps) => {
  return (
    <div className="data-head mb-2">
      <h6 className="overline-title m-0">{title}</h6>
    </div>
  );
};
